import { ajax } from './ajax'

class Log {
  constructor (name, parent) {
    this._name = name || 'LOG'
    this._parent = parent
    if (parent) {
      this._remoteLevel = parent._remoteLevel
      this._remoteEndpoint = parent._remoteEndpoint
    } else {
      this._remoteLevel = null
      this._remoteEndpoint = null
    }
  }

  name (name) {
    if (name) {
      this._name = name
    } else {
      return this._name
    }
  }

  for (clazz) {
    return new Log(clazz, this)
  }

  _toPriority (level) {
    if (level === 'error') {
      return 1
    }
    if (level === 'warn') {
      return 2
    }
    if (level === 'info') {
      return 3
    }
    if (level === 'debug') {
      return 4
    }
    return 0
  }

  _log (level, msg) {
    const method = console[level]
    if (!method) {
      console.warn('Unknown log level: ' + method)
      console.log(msg)
      return
    }

    const n = this._parent ? (this._parent.name() + ' (' + this._name + ')') : this._name
    if (navigator.userAgent.indexOf('Chrome') !== -1) {
      // Browsers like safari dont log the styling properly, fml
      method('%c ' + n + ' -> ' + msg,
        'background-image: url(https://ads.smrtb.com/icon_small.png); background-repeat: no-repeat; background-position: left center; padding-left: 12px')
    } else {
      method(n + ' -> ' + msg)
    }

    if (this._toPriority(level) <= this._toPriority(this._remoteLevel)) {
      const now = new Date()
      ajax(this._remoteEndpoint, now.getTime() + ' - ' + level + ' - ' + msg)
    }
  }

  debug (msg) {
    this._log('debug', msg)
  }

  info (msg) {
    this._log('info', msg)
  }

  warn (msg) {
    this._log('warn', msg)
  }

  error (msg) {
    return this._log('error', msg)
  }
}

export default new Log()
